'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiStopwatch = function TiStopwatch(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.4 14.8c0.1 0 0.3-0.1 0.4-0.3l0.9-0.8c0.6-0.7 0.6-1.7 0-2.4s-1.7-0.6-2.4 0l-0.8 0.9c-0.1 0-0.1 0.1-0.2 0.2-2.3-2.1-5.3-3.6-8.7-4 0.1 0 0.1 0 0.1-0.1v-1.6h1.6c1 0 1.7-0.8 1.7-1.7s-0.7-1.7-1.7-1.7h-6.6c-0.9 0-1.7 0.8-1.7 1.7s0.8 1.7 1.7 1.7h1.6v1.6c0 0.1 0.1 0.1 0.1 0.1-7.6 0.8-13.4 7.2-13.4 14.9 0 8.3 6.7 15 15 15s15-6.7 15-15c0-3.1-1-6-2.6-8.5z m-12.4 20.2c-6.4 0-11.7-5.2-11.7-11.7s5.3-11.6 11.7-11.6 11.7 5.2 11.7 11.6-5.3 11.7-11.7 11.7z m1.7-13.3v-3.4c0-0.9-0.8-1.6-1.7-1.6s-1.7 0.7-1.7 1.6v5c0 1 0.8 1.7 1.7 1.7h5c0.9 0 1.7-0.7 1.7-1.7s-0.8-1.6-1.7-1.6h-3.3z m-1.7-8.4c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.4 10-10-4.5-10-10-10z m0 18.4c-4.6 0-8.3-3.8-8.3-8.4s3.7-8.3 8.3-8.3 8.3 3.7 8.3 8.3-3.7 8.4-8.3 8.4z' })
        )
    );
};

exports.default = TiStopwatch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/stopwatch.js
// module id = 3987
// module chunks = 0